import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M24 6a17.97 17.97 0 0 0-14.017 6.706 2 2 0 0 1-.014-.21L9.967 7a1 1 0 1 0-2 0l.002 5.496a3.5 3.5 0 0 0 3.498 3.5l5.48.004a1 1 0 1 0 .001-2l-5.436-.004A15.97 15.97 0 0 1 24 8c8.837 0 16 7.163 16 16s-7.163 16-16 16S8 32.837 8 24a1 1 0 1 0-2 0c0 9.941 8.059 18 18 18s18-8.059 18-18S33.941 6 24 6"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M23 23h-8c-1.333 0-1.333 2 0 2h8.994c.335 0 .61-.078.772-.229.163-.15.234-.443.234-.77V10.82c0-.419-.545-.819-1.028-.819-.484 0-.876.274-.972.819z"
    }
  )
);
var SvgHistoryOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var HistoryOutlined_default = SvgHistoryOutlined;

export { HistoryOutlined_default as default };
